import type { Option } from "@tento-lona/sheets";
import { DateTime, NaiveDate, Utc } from "@tento-chrono";
import { invariant } from "@tento-core/assert";
import type { RowId } from "@tento-lona/sheets";

// Every check below runs on hot paths (each cell fetch, each row handle), so a
// passing check returns before its failure message — a `JSON.stringify` or a
// date's `toString` — is built: the message is made only for the violation.

export function requireNonEmptyKey(
  where: string,
  field: string,
  value: Option<string>,
): asserts value is string {
  if (typeof value === "string" && value.trim().length > 0) return;
  invariant(
    typeof value === "string",
    `${where}: ${field} must be a non-empty key (got ${JSON.stringify(value)})`,
    { where, field, value },
  );
  invariant(
    false,
    `${where}: ${field} must be a non-empty key (got ${JSON.stringify(value)})`,
    { where, field, value },
  );
}

export function requireRowId(
  where: string,
  rowId: Option<RowId>,
): asserts rowId is RowId {
  invariant(
    rowId != null,
    `${where}: rowId must be a non-empty key (got null)`,
    { where, field: "rowId", value: null },
  );
  requireNonEmptyKey(where, "rowId", rowId.toString());
}

export function requireDateTimeRange(
  where: string,
  field: string,
  range: Option<DateTime.Range<Utc>>,
): asserts range is DateTime.Range<Utc> {
  if (range != null && range.start.mse <= range.end.mse) return;
  invariant(
    range != null,
    `${where}: ${field} must be a date-time range (got null)`,
    { where, field, value: null },
  );
  invariant(
    false,
    `${where}: ${field} start must not be after end`,
    {
      where,
      field,
      start: range.start.toString(),
      end: range.end.toString(),
    },
  );
}

export function requireNaiveDateRange(
  where: string,
  field: string,
  range: Option<NaiveDate.Range>,
): asserts range is NaiveDate.Range {
  if (range != null && range.start.dse <= range.end.dse) return;
  invariant(
    range != null,
    `${where}: ${field} must be a date range (got null)`,
    { where, field, value: null },
  );
  invariant(
    false,
    `${where}: ${field} start must not be after end`,
    {
      where,
      field,
      start: range.start.toString(),
      end: range.end.toString(),
    },
  );
}
